import { render, staticRenderFns } from "./ChatImageMessage.vue?vue&type=template&id=3da141f6&scoped=true&lang=pug"
import script from "./ChatImageMessage.vue?vue&type=script&lang=js"
export * from "./ChatImageMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatImageMessage.vue?vue&type=style&index=0&id=3da141f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da141f6",
  null
  
)

export default component.exports